import { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import useCopyToClipboard from "@/shared/hooks/use-copy-to-clipboard";
import toast from "react-hot-toast";
import MxDetailCard from "@rf-l1/page/details/MxDetailCard";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import BuildingItem from "./components/BuildingItem";
import MobileView from "./components/MobileView";
import { useProjectTableColumns } from "./hooks/useProjectTableColumns";
import { useWidth } from "@/shared/hooks/use-width.hook";

function DetailPropertyProjectTable() {
  const { buildings, isProject, projectTypeId } = usePropertyDetailPage();
  const [expandedBuildings, setExpandedBuildings] = useState<number[]>([]);
  const [, copy] = useCopyToClipboard();
  const visibleColumns = useProjectTableColumns(projectTypeId || undefined);
  const width = useWidth();

  useEffect(() => {
    // Inicializar todos los edificios como cerrados (sin expandir)
    setExpandedBuildings([]);
  }, [buildings]);

  const handleCopyId = useCallback(
    (id: number) => {
      copy(id.toString());
      toast.success("ID copiado al portapapeles");
    },
    [copy]
  );

  const toggleBuilding = useCallback((buildingId: number) => {
    setExpandedBuildings(prev =>
      prev.includes(buildingId)
        ? prev.filter(id => id !== buildingId)
        : [...prev, buildingId]
    );
  }, []);

  if (!isProject || !buildings || buildings.length === 0) {
    return null;
  }

  // Vista Mobile
  if (width === "xs" || width === "sm") {
    return (
      <MxDetailCard>
        <MxDetailSubTitle label="Etapa o bloque" />
        <Box sx={{ mt: 2, width: "100%" }}>
          <MobileView
            buildings={buildings}
            expandedBuildings={expandedBuildings}
            visibleColumns={visibleColumns}
            onToggle={toggleBuilding}
            onCopyId={handleCopyId}
          />
        </Box>
      </MxDetailCard>
    );
  }

  // Vista Desktop
  return (
    <MxDetailCard>
      <MxDetailSubTitle label="Etapa o bloque" />
      <Box sx={{ mt: 3, width: "100%" }}>
        {buildings.map((building, index) => (
          <BuildingItem
            key={building.id || index}
            building={building}
            buildingIndex={index}
            isExpanded={expandedBuildings.includes(building.id)}
            projectTypeId={projectTypeId || 0}
            visibleColumns={visibleColumns}
            onToggle={toggleBuilding}
            onCopyId={handleCopyId}
          />
        ))}
      </Box>
    </MxDetailCard>
  );
}

export default DetailPropertyProjectTable;
